// Account limits take precedence over connection/public service health. A
// Retry-After deadline permits another attempt; it does not prove recovery.
export const providerAvailabilityLabel = availability => {
  if (availability?.kind === 'out-of-tokens') return 'Out of tokens'
  if (availability?.kind === 'rate-limited') return 'Rate limited (429)'
  return ''
}

export const providerAvailabilityDetail = availability => {
  const label = providerAvailabilityLabel(availability)
  if (!label) return ''
  const retryAt = Number(availability.retryAt)
  const retry = Number.isFinite(retryAt) && retryAt > 0
    ? retryAt > Date.now() ? ` Try again after ${new Date(retryAt).toLocaleString()}.` : ' You can try again now.'
    : ''
  return (availability.kind === 'out-of-tokens'
    ? 'This provider reported no remaining tokens, credits, or subscription allowance. Check your plan or choose another provider.'
    : 'This provider is limiting requests.' + (retry ? '' : ' Try again later.') + ' You can also choose another provider.') + retry
}
